export const EVENT_KEYS = {
  rog: 'instant_rog',
}